export default __webpack_public_path__ + "static/media/f5.942bc30f.svg";